import styled from "styled-components";

export const RadioHiddenInput = styled.input`
  position: absolute;
  left: 0.625rem;
  opacity: 0;
  z-index: -1;
`;
export default RadioHiddenInput;
